var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowRightEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9175_113251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.06752L8 12.9325C8 13.3564 8.49443 13.588 8.82009 13.3166L13.5391 9.38411C13.7789 9.18421 13.7789 8.81579 13.5391 8.61589L8.82009 4.68341C8.49443 4.41202 8 4.6436 8 5.06752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10,
    transform: "matrix(1 0 0 -1 15 14)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.06752L2 12.9325C2 13.3564 2.49443 13.588 2.82009 13.3166L7.53907 9.38411C7.77894 9.18421 7.77895 8.81579 7.53907 8.61589L2.82009 4.68341C2.49443 4.41202 2 4.6436 2 5.06752Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9175_113251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightEnd);
export default __webpack_public_path__ + "static/media/ic-arrow-right-end.7fb6502f1352c4840778c6fd778cddbd.svg";
export { ForwardRef as ReactComponent };